<template>
  <div id="app">
    <OrganismLimitDate
      v-if="$store.getters.getAcademyDaysLeft === 0 &&
        // /actualizar-licencia
        $route.path !== `/${this.$t('rPaths.updatingLicence')}` &&
        // /actualizar-mi-plan
        $route.path !== `/${this.$t('rPaths.updateMyPlan')}` &&
        $route.path !== '/login' &&
        $route.path !== '/logout' &&
        // /gestion/plan-personalizado
        !$route.path.startsWith(`/${$t('rPaths.billing')}/${$t('mEditionMenu.billing.customizedPlan.subject')}`)"
    />
    <router-view name="view"/>
    <OrganismTheAlerts/>
    <OrganismTheModal/>
    <OrganismFloatingButton/>
  </div>
</template>

<script>
export default {
  name: 'App',

  components: {
    OrganismFloatingButton: () => import('@/components/organisms/OrganismFloatingButton'),
    OrganismLimitDate: () => import('@/components/organisms/OrganismLimitDate'),
    OrganismTheAlerts: () => import('@/components/organisms/OrganismTheAlerts'),
    OrganismTheModal: () => import('@/components/organisms/OrganismTheModal')
  },

  computed: {
    isTrialExpired () {
      return this.$store.getters.getAcademyDaysLeft === 0
    }
  },

  watch: {
    $route (to, from) {
      if ((from.name === 'asset' || from.name === 'map' || from.name === 'product') &&
        from.params.subject === 'tarjeta') {
        if (this.$store.getters.getAssetEdition) {
          this.$modal.showModal('MoleculeEditionExitModal', from)
        }
      }
    },

    isTrialExpired (newVal) {
      if (newVal) {
        // Bloquea clic derecho si expiró el trial
        document.addEventListener('contextmenu', this.disableRightClick)
      } else {
        document.removeEventListener('contextmenu', this.disableRightClick)
      }
    }
  },

  mounted () {
    // Por si ya está en 0 al montar
    if (this.isTrialExpired) {
      document.addEventListener('contextmenu', this.disableRightClick)
    }
  },

  beforeDestroy () {
    document.removeEventListener('contextmenu', this.disableRightClick)
  },

  created () {
    setTimeout(() => {
      const iframe = document.querySelector('iframe[data-product="web_widget"]')
      if (iframe) iframe.removeAttribute('allow')
    }, 350)
  },

  methods: {
    disableRightClick (e) {
      e.preventDefault()
    }
  }
}
</script>

<style src="./styles/main.css"></style>
